<span class="user-search-multi-select"
      [class.p-float-label]="showFloatLabel">
  <p-multiSelect
    [options]="users"
    [(ngModel)]="selectedUsers"
    (onChange)="onSelectionChange($event.value)"
    (onFilter)="onFilter($event)"
    (onPanelShow)="onPanelShow()"
    (onPanelHide)="onPanelHide()"
    [filter]="true"
    filterBy="name"
    dataKey="id"
    optionLabel="name"
    [showToggleAll]="false"
    dropdownIcon="pi pi-search"
    scrollHeight="400px"
    styleClass="w-full"
    [placeholder]="showFloatLabel ? '' : placeholder"
    selectedItemsLabel="Выбрано: {0}"
    [maxSelectedLabels]="2"
    [emptyFilterMessage]="loading ? 'Загрузка...' : 'Нет результатов'"
    [emptyMessage]="loading ? 'Загрузка...' : placeholder"
  >
    <ng-template pTemplate="selectedItems">
      <div>
        <ng-container *ngIf="!selectedUsers?.length">
          {{ showFloatLabel ? labelInput : placeholder }}
        </ng-container>

        <ng-container *ngIf="selectedUsers?.length > 2; else usersPreview">
          Выбрано: {{ selectedUsers.length }}
        </ng-container>

        <ng-template #usersPreview>
          <ng-container *ngFor="let user of selectedUsers; last as isLast">
            {{ toUser(user).name }}{{ isLast ? '' : ', ' }}
          </ng-container>
        </ng-template>
      </div>
    </ng-template>

    <ng-template let-user pTemplate="item">
      <div *ngIf="toUser(user) as item">
        <div>{{ item.name }}</div>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div *ngIf="loading || loadingMore" class="user-search-multi-select__panel-loader">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Загрузка...</span>
      </div>
    </ng-template>
  </p-multiSelect>

  <label *ngIf="showFloatLabel">{{ labelInput }}</label>

  <i *ngIf="loading || loadingMore"
     class="pi pi-spin pi-spinner user-search-multi-select__field-loader"
     aria-hidden="true"></i>
</span>
